import { render, staticRenderFns } from "./DinnerUpDateStudent.vue?vue&type=template&id=425e5663&scoped=true&"
import script from "./DinnerUpDateStudent.vue?vue&type=script&lang=js&"
export * from "./DinnerUpDateStudent.vue?vue&type=script&lang=js&"
import style0 from "./DinnerUpDateStudent.vue?vue&type=style&index=0&id=425e5663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e5663",
  null
  
)

export default component.exports